export default {
  ADD_OUTPUT_RESULT: 'addOutputResult',
  CLEAR_OUTPUT_LIST: 'clearOutputList',
}